var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    transform: "rotate(-90)",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.60254,178a11.994,11.994,0,0,1-16.39209,4.39209L140,148.78442V216a12,12,0,0,1-24,0V148.78442L57.78955,182.39209a11.99981,11.99981,0,0,1-12-20.78418L104.00024,128,45.78955,94.39209a11.99981,11.99981,0,1,1,12-20.78418L116,107.21558V40a12,12,0,0,1,24,0v67.21558l58.21045-33.60767a11.99981,11.99981,0,0,1,12,20.78418L151.99976,128l58.21069,33.60791A11.99957,11.99957,0,0,1,214.60254,178Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.0362fa04790772d95f6ea1e88f02538c.svg";
export { ForwardRef as ReactComponent };